import { useEffect } from 'react';
import i18next from 'i18next';
import MagexLogo from '../../Icons/Magex_logo.png';
import { useHistory } from 'react-router';
import localRequest from '../../services/LocalServer/localRequest';
import request from '../../services/Request';
import logger from '../../services/LocalServer/logger';
import { useTranslation } from 'react-i18next';

const getMachineURL = `${process.env.REACT_APP_LOCAL_API}/getMachine`;
const getPromoURL = `${process.env.REACT_APP_LOCAL_API}/getPromo`;
const getAllProdURL = `${process.env.REACT_APP_LOCAL_API}/getProduct`;
const getAllCateURL = `${process.env.REACT_APP_LOCAL_API}/getCategory`;
const getAllBrandURL = `${process.env.REACT_APP_LOCAL_API}/getBrand`;
const getReinstate = `${process.env.REACT_APP_LOCAL_API}/getReinstateStatus`;

const getMachineURLR = `${process.env.REACT_APP_SERVER_API}/machines/edit/`;
const getPromoURLR = `${process.env.REACT_APP_SERVER_API}/promos/machine/`;
const getAllProdURLR = `${process.env.REACT_APP_SERVER_API}/machines/getMachineUIproduct/`;
const getAllCateURLR = `${process.env.REACT_APP_SERVER_API}/machines/getFilteredCategroy/`;
const getAllBrandURLR = `${process.env.REACT_APP_SERVER_API}/machines/getFilteredBrand/`;

function Initial(props) {
  const { t } = useTranslation();
  const { stat, setStat } = props;
  const history = useHistory();
  const machineID = props.id;

  let outofStock = false;
  let items = [];
  let filteredProducts = [];
  let categoryArray = [];
  let language = 'en';
  const isLocal = localStorage.getItem('ISLOCAL') === 'TRUE';

  useEffect(async () => {
    console.log('islocal', isLocal);
    if (props.test !== 'true') {
      const instateStatus = new Promise((resolve, reject) => {
        localRequest({
          method: 'get',
          url: getReinstate,
        }).then((res) => {
          console.log('reinstate', res.data);
          if (res.data) resolve(1);
          else resolve(0);
        });
      });
      const isGo = await instateStatus;
      logger(2, 'App Restart = ' + isGo);

      const delay = (ms) => new Promise((res) => setTimeout(res, ms));

      if (isGo) {
        console.log('INI TIME', localStorage.getItem('INI_TIME'));
        await delay(localStorage.getItem('INI_TIME') ? localStorage.getItem('INI_TIME') : 10000);
      }
    }

    props.cleanUp();
    let myMachineObj = null;
    localStorage.removeItem('MagexApp.cart');
    localStorage.removeItem('promo');
    localStorage.removeItem('codePromo');
    localStorage.removeItem('oneTime');
    localStorage.removeItem('machine');
    localStorage.removeItem('products');
    localStorage.removeItem('category');
    localStorage.removeItem('brand');
    let machine = null;

    const voidMachine = (res, setDefaultLogo) => {
      let promise = new Promise((resolve, reject) => {
        try {
          const style = document.createElement('style');
          document.head.appendChild(style);

          if (res.data.themeColor) {
            if (res.data.themeColor.price) {
              document.body.style.setProperty('--price-color', res.data.themeColor.price);
            }
            //description color
            if (res.data.themeColor.plus) {
              document.body.style.setProperty('--description-color', res.data.themeColor.plus);
            }
            if (res.data.themeColor.text)
              document.body.style.setProperty('--text-color', res.data.themeColor.text);
            if (res.data.themeColor.button)
              document.body.style.setProperty('--buttons-color', res.data.themeColor.button);
            if (res.data.themeColor.background)
              document.body.style.setProperty('--background-color', res.data.themeColor.background);
            if (res.data.themeColor.secondary)
              document.body.style.setProperty('--secondary-color', res.data.themeColor.secondary);
            if (res.data.themeColor.search_form)
              document.body.style.setProperty(
                '--search-form-color',
                res.data.themeColor.search_form
              );
            if (res.data.themeColor.backgroundImage) {
              const bgURL = isLocal
                ? `
            .category-container {
                background-color: white;
                background-attachment: fixed;
                background-image: url(${process.env.REACT_APP_LOCAL_API}/pictures/machines/${res.data.themeColor.backgroundImage});
            }
        `
                : `
        .category-container {
            background-color: white;
            background-attachment: fixed;
            background-image: url(${process.env.REACT_APP_SERVER_API}/pictures/${res.data.themeColor.backgroundImage}/${res.data.belongTo});
        }
        `;
              style.sheet.insertRule(bgURL);
            } else {
              // document.querySelector(
              //   '.splash-container'
              // ).style.backgroundImage = `url(${SplashBackground})`;
            }
            if (res.data.themeColor.logo) {
              const logoURL = isLocal
                ? `
            .category-logo {
                content:url(${process.env.REACT_APP_LOCAL_API}/pictures/machines/${res.data.themeColor.logo});
            }
              `
                : `
              .category-logo {
                  content: url(${process.env.REACT_APP_SERVER_API}/pictures/${res.data.themeColor.logo}/${res.data.belongTo})
              }
              `;
              // document.querySelector('.homeImg').style.content = `url(${MagexLogo})`;
              style.sheet.insertRule(logoURL);
            } else {
              style.sheet.insertRule(`
            .category-logo {
                content: url(${MagexLogo})
            }
            `);
            }
          }
          //set primary language
          i18next.changeLanguage(res.data.languages[0].code);
          props.setlangs(res.data.languages[0].code);
          localStorage.setItem('machineID', machineID);
          localStorage.setItem('machine', JSON.stringify(res.data));
          myMachineObj = res.data;
          props.setMachine(res.data);
          machine = res.data;
          logger(2, 'Void Machine Complete');
          resolve('done');
        } catch (e) {
          logger(0, 'Void Machine Error = ' + JSON.stringify(e));
          history.push(`/machineUI/slider/${machineID}`);
        }
      });

      promise.then();
    };

    const voidProd = async (res) => {
      let copy = [...res?.data];
      let products = res?.data;
      console.log('voidProdvoidProd');
      if (
        copy?.length == 0 &&
        process.env.REACT_APP_DEV === 'TRUE' &&
        process.env.REACT_APP_DEV_MACHINE_ID
      ) {
        console.log('voidProdvoi222222dProd');
        await request({
          method: 'get',
          url: getAllProdURLR + process.env.REACT_APP_DEV_MACHINE_ID,
        }).then((res) => {
          console.log('3333333');
          copy = [...res.data];
          products = res.data;
        });
      }

      try {
        const bestMachineArray = myMachineObj.products_bs;
        const bestSeller = [];

        if (props.test === 'true' || process.env.REACT_APP_DEV === 'TRUE') {
          console.log('goes in');
          copy.forEach((item, i) => {
            // current_stock will not be 0
            item.current_stock = 4;
            item.idx = i;
            if (!item.name.es) {
              item.name.es = '';
            }
            if (!item.name.fr) {
              item.name.fr = '';
            }
          });
          bestMachineArray.forEach((bsProd) => {
            let index = copy.findIndex((e) => e._id == bsProd);
            if (index > -1) {
              bestSeller.push(copy[index]);
            }
          });
          localStorage.setItem('bestSeller', JSON.stringify(bestSeller));
        } else {
          // console.log('itemin', items);
          // console.log('allprod', products);
          let i = 0;

          items.forEach((item) => {
            let index = products.findIndex((e) => e.upc === item.upc);
            if (index >= 0) {
              products[index].current_stock = item.current_stock;
              products[index].max_stock = item.max_stock;
              products[index].idx = i;
              if (!products[index].name.es) {
                products[index].name.es = '';
              }
              if (!products[index].name.fr) {
                products[index].name.fr = '';
              }
              i++;
              filteredProducts.push(products[index]);
            }
          });
          i = 0;
          // console.log('filteredProduct', filteredProducts);
          // console.log('bestMachineArray', bestMachineArray);
          bestMachineArray.forEach((bsProd) => {
            let index = filteredProducts.findIndex((e) => e._id == bsProd);
            if (index > -1) {
              bestSeller.push(filteredProducts[index]);
            }
          });
          localStorage.setItem('bestSeller', JSON.stringify(bestSeller));
          console.log('bbsl', bestSeller);
        }
        logger(2, 'Void Product Complete');
      } catch (e) {
        logger(0, 'Void Product Error = ' + JSON.stringify(e));
        history.push(`/machineUI/slider/${machineID}`);
      }
      try {
        const codePromo = JSON.parse(localStorage.getItem('promo'));
        console.log(codePromo);
        //  console.log(codePromo)
        if (codePromo.length > 0) {
          codePromo.forEach((item, promoIndex) => {
            if (item.promoType === 'buyXProducts') {
              if (item.cateOrProd === 'prod') {
                if (item.product) {
                  for (let i = 0; i < item.product.length; i++) {
                    for (let j = 0; j < products.length; j++) {
                      if (item.product[i]._id == products[j]._id) {
                        products[j].discountedPrice = item.percentage
                          ? products[j].price * (1 - item.amount)
                          : products[j].price - item.amount;
                        products[j].discountedPrice =
                          Math.round(products[j].discountedPrice * 100) / 100;
                        products[j].buyX = item.productsToBuy;
                        products[j].promo = item._id;
                        products[j].discount = item.amount;
                        products[j].percentage = item.percentage;
                        // products[j].discountedPrice = products[j].discountedPrice > 0 ? products[j].discountedPrice : 0;
                        // for checking prod promotion priority more
                        products[j].prodPromo = true;
                        products[j].promoIndex = promoIndex;
                      }
                    }
                  }
                }
              } else if (item.cateOrProd === 'All Products') {
                products.forEach((product) => {
                  products.promo = item._id;
                  product.percentage = item.percentage;
                  product.discountedPrice = item.percentage
                    ? product.price * (1 - item.amount)
                    : product.price - item.amount;
                  product.discountedPrice = Math.round(product.discountedPrice * 100) / 100;
                  product.discount = item.amount;
                  product.buyX = item.productsToBuy;
                  product.percentage = item.percentage;
                  product.promoIndex = promoIndex;
                });
              }
            } else if (
              item.promoType === 'general' ||
              item.promoType === 'emailCode' ||
              item.promoType === 'nextPurchase'
            ) {
              if (item.cateOrProd === 'cate') {
                if (item.category) {
                  for (let i = 0; i < item.category.length; i++) {
                    for (let j = 0; j < products.length; j++) {
                      if (
                        !products[j].prodPromo &&
                        products[j].category.includes(item.category[i]._id)
                      ) {
                        products[j].promo = item._id;
                        products[j].percentage = item.percentage;
                        if (item.promoType === 'nextPurchase') {
                          products[j].emailCode = true;
                          products[j].nextPurchase = true;
                          products[j].dis = item.amount;
                        } else {
                          if (item.promoType === 'emailCode') {
                            products[j].emailCode = true;
                          }
                          products[j].discountedPrice = item.percentage
                            ? products[j].price * (1 - item.amount)
                            : products[j].price - item.amount;
                          products[j].discountedPrice =
                            Math.round(products[j].discountedPrice * 100) / 100;
                          products[j].buyX = 0;
                          products[j].discount = item.amount;
                          products[j].percentage = item.percentage;
                        }
                      }
                    }
                  }
                }
              } else if (item.cateOrProd === 'prod') {
                if (item.product) {
                  for (let i = 0; i < item.product.length; i++) {
                    for (let j = 0; j < products.length; j++) {
                      if (item.product[i]._id == products[j]._id) {
                        products[j].percentage = item.percentage;
                        products[j].promo = item._id;
                        if (item.promoType === 'nextPurchase') {
                          products[j].emailCode = true;
                          products[j].nextPurchase = true;
                          products[j].dis = item.amount;
                        } else {
                          if (item.promoType === 'emailCode') {
                            products[j].emailCode = true;
                          }
                          products[j].discount = item.amount;
                          products[j].discountedPrice = item.percentage
                            ? products[j].price * (1 - item.amount)
                            : products[j].price - item.amount;
                          products[j].discountedPrice =
                            Math.round(products[j].discountedPrice * 100) / 100;
                          products[j].buyX = 0;
                          products[j].prodPromo = true;
                        }
                      }
                    }
                  }
                }
              } else if (item.cateOrProd === 'All Products') {
                products.forEach((product) => {
                  product.percentage = item.percentage;
                  product.promo = item._id;
                  if (item.promoType === 'nextPurchase') {
                    product.emailCode = true;
                    product.nextPurchase = true;
                    product.dis = item.amount;
                  } else {
                    if (item.promoType === 'emailCode') {
                      product.emailCode = true;
                    }
                    product.promo = item._id;
                    product.discountedPrice = item.percentage
                      ? product.price * (1 - item.amount)
                      : product.price - item.amount;
                    product.discountedPrice = Math.round(product.discountedPrice * 100) / 100;
                    product.buyX = 0;
                    product.discount = item.amount;
                  }
                });
              }
            }
          });
        }
        // initial products state
        if (props.test === 'true' || process.env.REACT_APP_DEV === 'TRUE') {
          console.log('copy', copy);
          props.setProds(copy);
        } else {
          props.setProds(filteredProducts);
        }
        logger(2, 'Promotion implementation complete');
      } catch (e) {
        logger(0, 'Errors when apply promotion to products. ' + JSON.stringify(e));
        history.push(`/machineUI/slider/${machineID}`);
      }
    };

    const getMachine = async () => {
      try {
        const setDefaultLogo = (style) => {
          document.querySelector('.homeImg').style.content = `url(${MagexLogo})`;
          style.sheet.insertRule(`
                  .category-logo {
                      content: url(${MagexLogo})
                  }
              `);
        };

        if (isLocal) {
          await localRequest({
            method: 'get',
            url: getMachineURL,
          })
            .then((res) => {
              voidMachine(res, setDefaultLogo);
            })
            .catch((err) => {
              logger(1, 'Errors when getLocalMachine = ' + JSON.stringify(err));
              console.log(err);
            });
        } else {
          await request({
            method: 'get',
            url: getMachineURLR + machineID,
          })
            .then((res) => {
              voidMachine(res, setDefaultLogo);
            })
            .catch((err) => {
              logger(1, 'Errors when getRemoteMachine = ' + JSON.stringify(err));
              console.log(err);
            });
        }
      } catch (e) {
        logger(0, 'Errors when getMachine = ' + JSON.stringify(e));
        history.push(`/machineUI/slider/${machineID}`);
      }
    };
    const getPromo = async () => {
      if (isLocal) {
        await localRequest({
          method: 'get',
          url: getPromoURL,
        })
          .then((res) => {
            console.log('localPromo', res.data);
            localStorage.setItem('promo', JSON.stringify(res.data));
          })
          .catch((err) => {
            logger(1, 'Errors when getLocalPromo = ' + JSON.stringify(err));
            console.log(err);
          });
      } else {
        await request({
          method: 'get',
          url: getPromoURLR + machineID,
        })
          .then((res) => {
            localStorage.setItem('promo', JSON.stringify(res.data));
          })
          .catch((err) => {
            logger(1, 'Errors when getRemotePromo = ' + JSON.stringify(err));
            console.log(err);
          });
      }
    };

    const updateStatus = async () => {
      console.log(props.test);

      if (props.test == 'false') {
        await localRequest({
          method: 'get',
          url: '/outOfOrderRequest',
        })
          .then((res) => {
            if (res.data.status) {
              outofStock = true;
              if (res.data.reason === 'MANUAL') {
                history.push(`/machineUI/out-of-order/${machineID}`);
              } else {
                history.push(`/machineUI/out-of-order/${machineID}`);
              }
            } else {
              outofStock = false;
            }
          })
          .catch((err) => {
            logger(1, 'Errors when get outOfOrderRequest = ' + JSON.stringify(err));
          });
      }

      if (props.test == 'false') {
        await localRequest({
          method: 'get',
          url: '/getInventory',
        })
          .then((res) => {
            if (res.data.items) {
              logger(2, 'Items = ' + JSON.stringify(res.data.items));
              items = res.data.items;
              // if (res.data.items_error && res.data.items_error.length > 0) {
              //   errorItems = res.data.items_error;
              //   console.log(errorItems);
              // }
            }
          })
          .catch((err) => {
            logger(1, 'Errors when get Inventory = ' + JSON.stringify(err));
          });
      }
    };
    async function getCates() {
      if (isLocal) {
        await localRequest({
          method: 'get',
          url: getAllCateURL,
        })
          .then((res) => {
            categoryArray = res.data;
            console.log('localCate', res.data);
            localStorage.setItem('category', JSON.stringify(res.data));
          })
          .catch((err) => {
            console.log(err);
            logger(1, 'Errors when downloading categorys' + JSON.stringify(err));
          });
      } else {
        await request({
          method: 'get',
          url: getAllCateURLR + machineID,
        })
          .then((res) => {
            categoryArray = res.data[0];
            localStorage.setItem('category', JSON.stringify(res.data[0]));
          })
          .catch((err) => {
            console.log(err);
            logger(1, 'Errors when downloading categorys' + JSON.stringify(err));
          });
      }
    }

    async function getBrands() {
      if (isLocal) {
        await localRequest({
          method: 'get',
          url: getAllBrandURL,
        })
          .then((res) => {
            console.log('localBrand', res.data);
            localStorage.setItem('brand', JSON.stringify(res.data));
          })
          .catch((err) => {
            console.log(err);
            logger(1, 'Errors when downloading brands' + JSON.stringify(err));
          });
      } else {
        await request({
          method: 'get',
          url: getAllBrandURLR + machineID,
        })
          .then((res) => {
            localStorage.setItem('brand', JSON.stringify(res.data[0]));
          })
          .catch((err) => {
            console.log(err);
            logger(1, 'Errors when downloading brands' + JSON.stringify(err));
          });
      }
    }

    async function getProds() {
      if (isLocal) {
        await localRequest({
          method: 'get',
          url: getAllProdURL,
        })
          .then(async (res) => {
            console.log('localProduct', res.data);
            voidProd(res);
          })
          .catch((err) => {
            console.log(err);
            logger(1, 'Errors when downloading products' + JSON.stringify(err));
          });
      } else {
        await request({
          method: 'get',
          url: getAllProdURLR + machineID,
        })
          .then(async (res) => {
            voidProd(res);
          })
          .catch((err) => {
            console.log(err);
            logger(1, 'Errors when downloading products' + JSON.stringify(err));
          });
      }
    }

    if (props.test == 'true') {
      localStorage.setItem('testMode', 'true');
      props.setTestMode(true);
    } else {
      localStorage.setItem('testMode', 'false');
      await updateStatus();
      props.setTestMode(false);
    }

    let run = async function () {
      await getPromo();
      await getMachine();
      await getProds();
      await getCates();
      await getBrands();
    };
    const nextPage = () => {
      try {
        stat.time = new Date();
        setStat(stat);
        //go to screensaver linked page directly instead of home page
        console.log('linkedpromo', props.linkPromo);
        console.log('ftproduct', filteredProducts);
        console.log('cate', categoryArray);
        let found = false;

        if (myMachineObj?.themeColor) {
          if (myMachineObj?.themeColor?.cart === '1') {
            localStorage.setItem('cartStyle', true);
          } else {
            localStorage.setItem('cartStyle', false);
          }

          if (
            myMachineObj.themeColor.c_column === '0' &&
            myMachineObj.themeColor.b_column === '0'
          ) {
            console.log('setHomesetHomesetHomesetHomesetHomesetHomesetHomesetHomesetHome');
            localStorage.setItem('homepage', `/machineUI/category/all/All Products/${machineID}`);
          } else if (myMachineObj.themeColor.c_column === '0') {
            localStorage.setItem('homepage', `/machineUI/brands/${machineID}`);
          } else {
            localStorage.setItem('homepage', `/machineUI/category/${machineID}`);
          }
        } else {
          localStorage.setItem('homepage', `/machineUI/category/${machineID}`);
        }

        if (localStorage.getItem('MSC') === 'TRUE') {
          logger(2, 'going to MSC page');
          history.push(`/machineUI/MSC/${machineID}`);
        } else {
          if (props.linkPromo) {
            if (props.linkPromo?.id !== '') {
              if (props.linkPromo?.p === 'prod') {
                filteredProducts.forEach((e) => {
                  if (e._id === props.linkPromo.id) {
                    found = true;
                    console.log('gogo');
                    history.push(`/machineUI/product/${machineID}/${e._id}/${e.idx}`);
                  }
                });
              }
              if (props.linkPromo?.p === 'cate') {
                categoryArray.forEach((e) => {
                  if (e._id === props.linkPromo.id) {
                    if (!e.name[language] || !e.name[language] === '') {
                      e.name[language] = e.name.en;
                    }
                    localStorage.setItem('currentCate', JSON.stringify(e));
                    found = true;
                    history.push(`/machineUI/category/cate/${e._id}/${machineID}`);
                  }
                });
              }
            }
            if (!found) {
              const homepage = localStorage.getItem('homepage');
              history.push(homepage);
            }
          }
        }
      } catch (err) {
        logger(0, 'Errors when go to next page' + JSON.stringify(err));
        history.push(`/machineUI/slider/${machineID}`);
      }
    };
    if (!outofStock) {
      run().then((e) => {
        nextPage();
      });
    }

    return () => {};
  }, []);

  return (
    <div className="d-flex justify-content-center align-items-center">
      <div className="init-div">{t(`Initializing...`)}</div>
    </div>
  );
}
export default Initial;
